export const ASSET_MOVE_REASON_OTHER = 'Other(Specify)';

export const assetMoveReasons = [
  'Collapsed Lot',
  'Contract Not Signed',
  'Duplicate - Asset Entered in Error',
  'Legal Issues',
  'Lien Issues',
  'Mechanical Issues',
  'Move to Next Auction',
  'Move to different channel',
  'Not Delivered',
  'Owner removed – Out on Rent / Needed for job / Not Selling',
  'Title Not Received',
  'Title Issue – Correction Required',
  'Transportation Issues',
  'VIN Plate Issue – Missing, OBL, Correction Required',
   ASSET_MOVE_REASON_OTHER
];
